<template>
  <div id="top" class="main_div">
    <ContentHeader class="content" />
    <div v-if="this.$vuetify.breakpoint.lgAndUp" class="photos_gallery">
      <v-layout>
        <v-col class="columns mt-1" cols="4">
          <div v-for="(item) in selectedPhotos[0]" :key="item.id">
            <router-link
              v-if="mode=='travel'"
              :to="{ name: 'CarouselTravel', params: {id: voyage_id, index: item[1]}}"
            >
              <v-img contain class="photo" :src="item[0]"></v-img>
            </router-link>
          </div>
        </v-col>
        <v-col class="columns mt-1" cols="4">
          <div v-for="(item) in selectedPhotos[1]" :key="item.id">
            <router-link
              v-if="mode=='travel'"
              :to="{ name: 'CarouselTravel', params: {id: voyage_id, index: item[1]}}"
            >
              <v-img contain class="photo" :src="item[0]"></v-img>
            </router-link>
          </div>
        </v-col>
        <v-col class="columns mt-1" cols="4">
          <div v-for="(item) in selectedPhotos[2]" :key="item.id">
            <router-link
              v-if="mode=='travel'"
              :to="{ name: 'CarouselTravel', params: {id: voyage_id, index: item[1]}}"
            >
              <v-img contain class="photo" :src="item[0]"></v-img>
            </router-link>
          </div>
        </v-col>
      </v-layout>
      <v-layout>
        <Footer class="footer mt-5" />
      </v-layout>
    </div>
    <div v-else class="photos_gallery">
      <v-layout>
        <v-col cols="1"></v-col>
        <v-col class="columns mt-1" cols="10">
          <div v-for="(item) in selectedPhotosPhone" :key="item.id">
            <router-link
              v-if="mode=='travel'"
              :to="{ name: 'CarouselTravel', params: {id: voyage_id, index: item[1]}}"
            >
              <v-img contain class="photo" :src="item[0]"></v-img>
            </router-link>
          </div>
        </v-col>
      </v-layout>
      <v-layout>
        <Footer class="footer mt-5" />
      </v-layout>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
import axios from "axios";
import {mapState, mapMutations} from 'vuex'
export default {
  name: "Gallery",
  data() {
    return {
      photoTravel: []
    };
  },
  components: {
    ContentHeader,
    Footer
  },
  props: {
    mode: String,
    voyage_id: Number
  },
  mounted() {
    if (this.mode == "travel") {
      axios
        .get("https://pascaldemunckbackend.com/api/photos/1/getTravelPhotos/")
        .then(res => {
          this.photoTravel = res.data;
        });
    } else {
      this.$store.dispatch("getPhotos");
    }
  },
  computed: {
    ...mapState([
      'carouselTravel'
    ]),
    photos() {
      return this.$store.state.photos;
    },
    selectedPhotosPhone() {
      var res = [];
      if (this.mode == "travel") {
        for (var i = 0; i < this.photoTravel.length; i++) {
          if (
            this.photoTravel[i]["voyage"] == this.voyage_id &&
            this.mode == "travel"
          ) {
            res.push([String('https://pascaldemunckbackend.com'+this.photoTravel[i]["image"]), this.photoTravel[i]["id"]]);
          }
        }
      } else {
        for (var j = this.photos.length - 1; j >= 0; j--) {
          if (
            this.photos[j]["recent"] &&
            res.length < 50 &&
            this.mode == "recent"
          ) {
            res.push([this.photos[j]["image"], this.photos[j]["id"]]);
          }
        }
      }
      if(this.mode == "travel"){
        this.SET_CAROUSELTRAVEL(res)
      }
      return res

    },
    selectedPhotos(){
      var res=this.selectedPhotosPhone
      var e1 = [];
      var e2 = [];
      var e3 = [];
      var index = 1;
      for (var i = 0; i < res.length; i++) {
        if (index == 3) {
          e3.push(res[i]);
          index = 1;
        } else if (index == 2) {
          e2.push(res[i]);
          index++;
        } else if (index == 1) {
          e1.push(res[i]);
          index++;
        }
      }
      return [e1, e2, e3];
    },
  },
  methods: {
    ...mapMutations([
      'SET_CAROUSELTRAVEL'
    ]),
  }
};
</script>

<style scoped>
.photo {
  transform: scale(1.05);
  transition: transform 0.5s;
}
.footer {
  width: 100%;
}
.title {
  position: absolute;
  top: 12%;
  left: 43%;
}
.content {
  width: 100%;
  height: 10%;
  background-color: black;
  position: absolute;
  top: 0%;
}

.columns {
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.photo:hover {
  transform: scale(1.15);
}

.photos_gallery_port {
  position: absolute;
  width: 100%;
  top: 26%;
}

.photos_gallery {
  position: absolute;
  width: 100%;
  top: 108px;
}
</style>